import { render, staticRenderFns } from "./SelectRole.vue?vue&type=template&id=12f2f1ad"
import script from "./SelectRole.vue?vue&type=script&lang=js"
export * from "./SelectRole.vue?vue&type=script&lang=js"
import style0 from "./SelectRole.vue?vue&type=style&index=0&id=12f2f1ad&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports